import Request from "../Request/Request";
import css from "./Queue.module.css";

const MAX_VISIBLE = 4;

const Queue = ({ limit, onComplete, onTimeout, requests, statuses }) => {
  const filtered = requests.filter((request) =>
    statuses.includes(request.status),
  );
  const visible = filtered.slice(0, MAX_VISIBLE);
  const overflow = filtered.length - visible.length;

  return (
    <div className={`${css.main} ${filtered.length > 0 ? css.active : ""}`}>
      {overflow > 0 && <p className={css.length}>+{overflow}</p>}
      {visible.map((request, index) => {
        return (
          <Request
            key={request.id}
            request={request}
            onComplete={onComplete}
            onTimeout={onTimeout}
            style={{
              marginRight:
                request.status === "queued" ? `${index * 1.25}rem` : 0,
              zIndex: MAX_VISIBLE - index,
            }}
          />
        );
      })}
      {limit > 0 && <p className={css.limit}>LIMIT: {limit}</p>}
    </div>
  );
};

export default Queue;
